function getProductInventoryDelivery(config, availability) {
    var ref;
    const missingDeliveryDays = config.missingInventoryChannelStrategy.expectedDeliveryDays;
    if (typeof availability === 'undefined') {
        return missingDeliveryDays;
    }
    const availableChannels = availability.channels || {};
    const channels = Object.entries(availableChannels);
    if (!channels.length) {
        return missingDeliveryDays;
    }
    // !!! Platform has no support for multiple channels yet.
    const [channelId, channel] = channels[0];
    const channelDeliveryConfig = (channel === null || channel === void 0 ? void 0 : channel.key) && ((ref = config.inventoryChannels) === null || ref === void 0 ? void 0 : ref[channel.key]) || config.inventoryChannels[channelId];
    if (!channelDeliveryConfig) {
        console.error(`Inventory channel ${channel.key || channelId} is not configured.`);
        return missingDeliveryDays;
    }
    if (typeof channel.availableQuantity === 'undefined') {
        return missingDeliveryDays;
    }
    const stockKey = channel.availableQuantity > 0 ? 'onStock' : 'outOfStock';
    return channelDeliveryConfig.expectedDeliveryDays[stockKey];
}

export { getProductInventoryDelivery };
//# sourceMappingURL=get-product-inventory-delivery.js.map
